import React from 'react';
import './style.scss';
import { Table, Column, Loader, Checkbox } from '@smartplatform/ui';
import { useGetRecords } from 'root/admin/components/hooks';
import { CreateNew } from 'root/admin/components';

const TagsList = ({ rootPath, model }) => {
	const [showGeneralType, setShowGeneralType] = React.useState(false);
	const inqArray = showGeneralType ? [model, 'all'] : [model];
	const filter = { where: { type: { inq: [...inqArray] } }, order: 'weight desc, id asc' };
	const tabName = 'tags';
	const records = useGetRecords({ model: 'Tag', filter, tabName });
	const onTypeChange = () => setShowGeneralType(!showGeneralType);
	if (!records) {
		return <Loader />;
	}

	return (
		<div className="tag-list">
			<div className="top">
				<CreateNew link={`${rootPath}/${tabName}/new`} name="Новая Категория" />
				<Checkbox value={showGeneralType} label="Показывать общие категории" onChange={onTypeChange} />
			</div>

			<Table records={records} rootPath={rootPath}>
				<Column property="name" label="Название категории" />
				<Column property="weight" label="Вес категории" />
			</Table>
		</div>
	);
};

export default TagsList;
